import { Component, Input, ViewChild, OnDestroy, ElementRef, Optional, Inject } from '@angular/core';
import { IAuthorizationService } from '@pershing/pershing-core';

@Component({
    selector: 'f2-component',
    templateUrl: './f2.component.html'
})
export class F2Component implements OnDestroy {
    /*
	* This component should take id and data-params as input
	* This component will be used to as simple component expecting multiple entry in siteconfig.json file
    */
   container: any;
    @Input() id: string;
    @Input() class: string;
    @Input() dataParams: string;
    @Input() entitlement: string;
    @ViewChild('f2', { static: false }) f2AppRef: ElementRef;
    isAdaTheme: boolean = false;
    appSettings: any;
    isEntitledforView: boolean;

    constructor(@Optional() @Inject('AppSettings') appSettings: any, private authService: IAuthorizationService) {
        this.appSettings = appSettings;
    }
    ngOnInit() {
        if (this.entitlement !== undefined) {
            this.isEntitledforView = this.authService.isEntitled(this.entitlement);
        } else {
            this.isEntitledforView = true;
        }

        if (this.appSettings.themeType && this.appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
        }
    }
    ngOnDestroy() {
        if (this.f2AppRef && this.f2AppRef.nativeElement) {
            this.f2AppRef.nativeElement.remove();
        }
    }
}
